"use client";

import { pagesPath } from "@/utils/pages-path";
import { UnauthorizedRedirect } from "./UnauthorizedRedirect";

export function MemberDefaultLoginFallback({
  currentUrl,
}: {
  currentUrl: string;
}) {
  const loginPath = pagesPath.members.login.$url().path;

  return (
    <UnauthorizedRedirect
      comebackUrl={currentUrl}
      redirectUrl={loginPath}
      errorMessage="ログインが必要です"
    />
  );
}

export function MemberDefaultVerifyFallback({
  currentUrl,
}: {
  currentUrl: string;
}) {
  const verifyAccountPath = pagesPath.members.verify_account.$url().path;
  return (
    <UnauthorizedRedirect
      comebackUrl={currentUrl}
      redirectUrl={verifyAccountPath}
      shouldLogout={false}
    />
  );
}

export function MemberDefaultMfaFallback({
  currentUrl,
}: {
  currentUrl: string;
}) {
  const mfaPath = pagesPath.members.mfa.$url().path;
  return (
    <UnauthorizedRedirect
      comebackUrl={currentUrl}
      redirectUrl={mfaPath}
      shouldLogout={false}
    />
  );
}

export function HealthInsuranceSocietyStaffLoginFallback({
  currentUrl,
}: {
  currentUrl: string;
}) {
  const loginPath = pagesPath.admin.login.$url().path;

  return (
    <UnauthorizedRedirect
      comebackUrl={currentUrl}
      redirectUrl={loginPath}
      errorMessage="ログインが必要です"
    />
  );
}
